import { Button, styled } from "@mui/material"

export const PracticeDeactivateButton: any = styled(Button, {
  shouldForwardProp: (prop) => prop !== "isActive",
})(({ isActive }: any) => {
  console.log("isActive", isActive)

  return {
    width: "120px",
    height: "40px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: isActive ? "#F3797E" : "#42B2A0",
    borderRadius: "4px",
    opacity: 1,
    color: isActive ? "#F3797E" : "#42B2A0",
    // backgroundColor: isActive ? "#E480811A" : "#F3797E1A",
    fontSize: "14px",
    textTransform: "capitalize",
    fontFamily: "Poppins",
  }
})
